import { render, staticRenderFns } from "./DistrictsForm.vue?vue&type=template&id=a87d7840&"
import script from "./DistrictsForm.vue?vue&type=script&lang=js&"
export * from "./DistrictsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports